export default function getFamilyMembers() {
    return [
        {value: "Father", label: "Father"},
        {value: "Mother", label: "Mother"},
        {value: "Sibling", label: "Sibling"}
    ];
}